<template>
    <b-form inline @submit.prevent="clickMe" class="w-md-25">
        <b-input-group>
            <b-input-group-prepend is-text>
                <b-icon icon="search" />
            </b-input-group-prepend>
            <b-form-input v-model="buscaNome" :placeholder="placeholder" />
            <b-input-group-append>
                <b-button type="submit">ok</b-button>
            </b-input-group-append>
        </b-input-group>
    </b-form>
</template>

<script lang="ts">
/**
 * Componente simples de busca inline para colocar nos topos de tabelas.
 * Emite um evento de busca quando o botão é clicado.
 */
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

const CompProps = Vue.extend({
    name: 'BuscaTabela',
    props: {
        placeholder: {
            type: String,
            default: 'Filtre os itens'
        }
    }
})
@Component
export default class BuscaTabela extends mixins(CompProps) {
    buscaNome = ''

    clickMe(): void {
        this.$emit('busca', this.buscaNome)
    }
}
</script>
